export const ns = "adminPanel.administrators"

export const role = {
  DIVISION: "divisionsupervisor",
  UNIVERSE: "universeadmin",
}
